// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Qy0a","location":"Header_location__2Y9VT"};